let getSettings = () => {
    return {
        // api : "http://localhost:3001",
        api : "https://inventorynode.herokuapp.com",
    }
}

export default getSettings()
